module.exports = "<stations-heatmap-page></stations-heatmap-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/stationsHeatmap.html
// module id = 1820
// module chunks = 0